import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { z } from 'zod'

const searchSchema = z.object({
	token: z.string(),
})

export const Route = createFileRoute('/signup/azure/callback')({
	validateSearch: zodValidator(searchSchema),
	beforeLoad: async ({ search, context: { clerk } }) => {
		if (!clerk.client) return

		await clerk.client.handleRedirectCallback({
			signUpForceRedirectUrl: `/signup/azure/confirm?token=${search.token}`,
			signInForceRedirectUrl: `/signup/azure/confirm?token=${search.token}`,
			continueSignUpUrl: `/signup/azure/confirm?token=${search.token}&continue=true`,
			verifyEmailAddressUrl: `/signup/azure/confirm?token=${search.token}&verifyEmail=true`,
			resetPasswordUrl: `/signup/azure/confirm?token=${search.token}&resetPassword=true`,
			secondFactorUrl: `/signup/azure/confirm?token=${search.token}&secondFactor=true`,
			firstFactorUrl: '/home',
		})
	},
})
